<template>
    <div class='el-porko-mafioso-tickets text-center'>
        <h6 class="text-center">{{'lucky_symbols' | lang}}</h6>
        <div class="lucky-symbols w-100 d-flex align-items-center justify-content-center">
            <div v-for="(symbol, itemIndex) in ticket.scenario.lucky_symbols" :key="itemIndex" :class="{'symbol d-flex align-items-center justify-content-center':true, 'lucky' : luckySymbolsArray.includes(symbol)}"> 
                <img class="img-fluid" :src="`/fg/v2/games/el_porko_mafioso/img/history/symbol_${symbol}${getSymbolPostfix(symbol)}.jpg`">
            </div>
        </div>
        <div v-if="luckyYourSymbols.length || luckyBonusSymbols.length" class="">
            <div v-if="luckyYourSymbols.length">
                <h6 class="text-center pt-3">{{'your_symbols' | lang}}</h6>
                <div class="your-symbols w-100 d-flex align-items-center justify-content-center justify-content-lg-start flex-wrap">
                    <div v-for="(item, itemIndex) in luckyYourSymbols" :key="itemIndex" class="symbol"> 
                        <img class="img-fluid" :src="`/fg/v2/games/el_porko_mafioso/img/history/symbol_${item.symbol}${getSymbolPostfix(item.symbol)}.jpg`">
                        <img v-if="item.twin" class="img-fluid twin" :src="`/fg/v2/games/el_porko_mafioso/img/history/twins_frame.png`">
                        <span class="amount">
                            {{item.amount}}
                        </span>
                    </div>
                </div>
            </div>
            <div v-if="luckyBonusSymbols.length">
                <h6 class="text-center pt-3" >{{'bonus' | lang}}</h6>
                <div class="bonus-symbols w-100 d-flex align-items-center justify-content-center">
                    <div class="card-holder" v-for="(item, itemIndex) in luckyBonusSymbols" :key="itemIndex">
                        <img class="img-fluid" :src="`/fg/v2/games/el_porko_mafioso/img/history/card.jpg`">
                        <span class="amount">{{item.amount}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class = 'no-winnings d-flex align-items-center justify-content-center'>
            <h6>{{'noWinning' | lang}}</h6>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['ticket', 'gameName'],
        data() {
            return {
                luckySymbolsArray:[]
            }
        },
        computed: {
            luckyYourSymbols() {
                let luckies = [];
                this.luckySymbolsArray = [];

                for (const [key, symbol] of Object.entries(this.ticket.scenario.your_symbols)) {
                    if (symbol.win) {
                        luckies.push(symbol);
                        this.luckySymbolsArray.push(symbol.symbol);
                    }
                }

                if (this.ticket.scenario.twins && this.ticket.scenario.twins.symbols) {
                    for (const [key, symbol] of Object.entries(this.ticket.scenario.twins.symbols)) {
                        let wasWin = false;

                        for(let i = 0; i < 2; i++) {
                            if (symbol[i].win) {
                                luckies.push(symbol[i]);
                                symbol[i].twin = true;
                                this.luckySymbolsArray.push(symbol[i].symbol);

                                wasWin = true;
                            }
                        }

                        if(wasWin) {

                        }
                    }
                }

                return luckies;
            },
            luckyBonusSymbols() {
                let luckies = [];

                if (this.ticket.scenario.bonus && this.ticket.scenario.bonus.symbols) {
                    for (const [key, symbol] of Object.entries(this.ticket.scenario.bonus.symbols)) {
                        if (symbol.win) {
                            luckies.push(symbol);
                        }
                    }
                }

                return luckies;
            }
        },
      methods: {
          getSymbolPostfix(name) {
            if (Config.assets.history_postfixes && Config.assets.history_postfixes[name]) {
              return Config.assets.history_postfixes[name];
            }

            return '';
          }
      },
    }
</script>

<style>
    .el-porko-mafioso-tickets .symbol {
        width: 20%;
        padding: 5px;
        max-width: 80px;
        position: relative;
    }

    .el-porko-mafioso-tickets .lucky-symbols .symbol {
        opacity: 0.5;
    }

    .el-porko-mafioso-tickets .lucky-symbols .symbol.lucky {
        opacity: 1;
    }

    .el-porko-mafioso-tickets .your-symbols .amount {
        position: absolute;
        bottom: 0px;
        text-align: center;
        font-family: Arco;
        width: 100%;
        font-size: 18px;
        left: 0;
        margin-left: auto;
        margin-right: auto;
        color: #fbed49;
        -webkit-text-stroke: 1.2px black;
        white-space: nowrap;
        transform: translateX(-50%);
        left: 50%;
    }

    .el-porko-mafioso-tickets .your-symbols .twin {
        position: absolute;
        top: 0px;
        left: 0px;
        padding: 5px;
    }

    .el-porko-mafioso-tickets .bonus-symbols .amount {
        text-align: center;
        font-family: Arco;
        font-size: 2em;
        left: 0;
        margin-left: auto;
        margin-right: auto;
        color: #fbed49;
        -webkit-text-stroke: 0.1rem black;
        white-space: nowrap;
        position: absolute;
        transform: translate(-50%,-50%);
        top: 50%;
        left: 50%;
    }

    .el-porko-mafioso-tickets .no-winnings {
        height: 100px;
        width: 100%;
        border: 1px white dotted;
        border-radius: 10px;
        margin-top: 15px;
    }

    .el-porko-mafioso-tickets .bonus-symbols .card-holder {
        width: 20%;
        position: relative;
        max-width: 80px;
    }

    .el-porko-mafioso-tickets .bonus-symbols .card-holder .text-holder {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
    }
</style>